import { useState } from "react";
import { useDialogPortal } from "@/hooks";
import { reallocatePoints } from "@/services";
import { safeAsync } from "@/utils";
import { reallocatePointsEventEmitter, REALLOCATE_POINTS_EVENTS } from "@/events";

interface UseReallocatePointsProps {
    newAddress: string;
}

export function useReallocatePoints({ newAddress }: UseReallocatePointsProps) {
    const [isLoading, setIsLoading] = useState(false);
    const { closeDialog } = useDialogPortal();

    const executeReallocatePoints = async () => {
        setIsLoading(true);

        const { result: transactionHash, error } = await safeAsync(() => reallocatePoints(newAddress));

        if (error || !transactionHash) {
            setIsLoading(false);
            throw error || new Error("Failed to get transaction hash");
        }

        reallocatePointsEventEmitter.emit(REALLOCATE_POINTS_EVENTS.SUCCESS, {
            newAddress,
            transactionHash,
        });

        closeDialog();
        setIsLoading(false);
    };

    return {
        executeReallocatePoints,
        isLoading,
    };
}
